export const ENV = {
  BUCKET_URL: process.env.REACT_APP_BUCKET_URL || "",
  API_URL:
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === "production"
      ? "https://admin.api.chewing.io"
      : "https://admin.api.dev.chewing.io"),
  GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID || "",
  SOCKET_URL:
    process.env.REACT_APP_SOCKET_URL ||
    (process.env.NODE_ENV === "production"
      ? "https://admin.api.chewing.io"
      : "https://admin.api.dev.chewing.io"),
  NODE_ENV: process.env.NODE_ENV || "development",
} as const;

// 이미지 URL 생성 헬퍼 함수
export const getImageUrl = (...paths: string[]): string => {
  return `${ENV.BUCKET_URL}/${paths.join("/")}`;
};
